import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {fetchCustomers} from "../../../../actions";
import {bbDangerousStringToDate} from "../../../../util/bbHelpers";
import BBDataTable from "../../tables/BBDataTable";
import {BRCustomizedTooltip as Tooltip} from "../../accents/BRCustomizedTooltip";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {renderCellExpand} from "../../tables/DataGridRenderCellExpand";
import BBIconContinuous from "../../../../assets/bbCustomIcons/BBIconContinuous";
import BBIconCheckCircleYes from "../../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconRoundedDashNull from "../../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import {HashLink as Link} from "react-router-hash-link";
import Select from "react-select";
import {KeyboardDatePicker} from "@material-ui/pickers";
import IntlMessages from "../../../../util/IntlMessages";
import {Button} from "reactstrap";


const Tile = (props) => {

    //selects customers object from state
    const { customers, loadingCustomers } = useSelector(({customer})=> customer);
    const dispatch = useDispatch();
    const [date, setDate] = useState(new Date(Date.now()- 30 * 24 * 60 * 60 * 1000));


    //api call to get customers object from state
    useEffect(()=>{
        if(!customers && !loadingCustomers){
            dispatch(fetchCustomers())
        }

    }, [customers, loadingCustomers, dispatch])

    const customersArray = customers && Object.values(customers);

    //newCustomer is the array created by converting customers object from state to an array and then filtering those objects to all those created
    //less than 7 days ago
    // const newCustomers = customers && Object.values(customers).filter(customer=> calcDiffDays(customer, "CreatedDate") < 7)
    const newCustomers = customers && customersArray && Array.isArray(customersArray) && customersArray.filter(customer=> new Date(customer["CreatedDate"]) > date)


    //tableData takes in newCustomers array and return an array with similar objects, but the objects now contained an id:index key/value pair,
    //which the datatable component requires. It also converts the Created Date key/value using the string to date function
    const tableData = newCustomers ? newCustomers.map((customer, index)=> {

        const customerSubs = Object.values(customer.Subscriptions)

        return {
            ...customer,
            id: index,
            CreatedDate: bbDangerousStringToDate(customer && customer.CreatedDate),
            hasCustomerSubs: Array.isArray(customerSubs) && customerSubs.length > 0,
            hasCIRT: !!customer.Stromboli,
            hasContAttacksEnabled: !!(customer.Stromboli && customer.Stromboli["Service Active"] === "1"),

        }
    }) : null

//title variable is for datatable, includes html formatting for title and relevant tooltip
    const title = <div>
        New Clients Information <Tooltip title={"Information about newest customers"}>
        <InfoSharpIcon style={{fontSize:"smaller"}}/>
    </Tooltip>
    </div>

    //tableheadings is an array of objects passed the data table, each object represents the column headings of the table
    const userTableHeadings = [
        { field: 'CustomerId', headerName: 'Customer Id', hide: true, flex: 1, sortable: true, type: 'string',},
        { field: 'id', headerName: "ID", hide: true, flex: 1, sortable: true, type: 'number'},
        { field: 'CustomerName', headerName: "Customer Name", hide: false, flex: 1, sortable: false, type: "string",
            renderCell: (params)=>
                renderCellExpand(params,
                    (<span>
                            <Link to={params.row.hasCIRT ? `/board/CIRT/external?clientID=${params.row.CustomerId}` : `/board/BreachRisk/Business/Report/TechData?clientID=${params.row.CustomerId}`}>
                                {params.value}
                            </Link>
                        </span>))},
        { field: 'CreatedDate', headerName: "Date", hide: false, width:100, sortable: true, type: "date"},
        { field: 'ServiceRequested', headerName: "Service Requested", hide: true, flex: 1, sortable: false, type: "number"},
        { field: 'hasCustomerSubs', headerName: " BreachRisk", hide: false, flex: 1, sortable: false, type: "string",
            renderCell: (params)=>
                renderCellExpand (params,
                    (params.value
                        ? <span className={"text-center"}>
                                <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                            </span>
                        :<span>
                                <BBIconRoundedDashNull/>
                             </span>
        ))},
        { field: 'hasCIRT', headerName: "CIRT", hide: false, flex: 1, sortable: false, type: "string",
            renderCell: (params)=>
                renderCellExpand (params,
                    (params.value
                            ? <span className={"text-center"}>
                                <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                            </span>
                            :<span>
                                <BBIconRoundedDashNull/>
                             </span>
                    ))},
        { field: 'hasContAttacksEnabled', headerName: "Continuous Attacks", hide:false, flex: 1, sortable: false, type: 'string',
            renderHeader: (params) =>
                (<span>
                        <BBIconContinuous/>
                </span>),
            renderCell: params =>
                renderCellExpand(params,
                    (params.value
                        ? <span className={"text-center"}>
                                <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                            </span>
                        :<span>
                                <BBIconRoundedDashNull/>
                             </span>
))
        },

    ]


    //BBDataTable is based on Materials Ui data grid, find component @ /components/customBreachBits/tables
    return(
        <div>
            {customers && newCustomers && tableData && newCustomers.length > 0 ?
                (
                    <BBDataTable
                    columns={userTableHeadings}
                    rows={tableData.sort((a,b)=> b.CreatedDate - a.CreatedDate)}
                    title={title}
                    progressValue={100}
                    loading={false}
                    rowsPerPageOptions = {[5, 10, 25, 50]}
                    defaultPageSize = {10}
                    defaultSortModel = {[
                        {
                            field: 'CreatedDate',
                            sort: 'desc',
                        },

                    ]}
                    topRightElement={<KeyboardDatePicker
                        margin="normal"
                        id="date"
                        name="date"
                        label={"New Customers Since"}
                        format="MM/DD/yyyy"
                        value={date}
                        maxDate={new Date(Date.now())}
                        onChange={(date) => setDate(date)}
                        KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}/>}
                    >
                </BBDataTable>
                ) :
                ( <BBDataTable
                    columns={userTableHeadings}
                    rows={[]}
                    title={title}
                    loading = {false}
                    totalRows={0}
                    progressValue={100}
                    bufferValue={0}
                    rowsPerPageOptions = {[5, 10, 25, 50]}
                    defaultPageSize = {10}
                    defaultSortModel = {[
                        {
                            field: 'CreatedDate',
                            sort: 'desc',
                        },

                    ]}
                    topRightElement={<KeyboardDatePicker
                        margin="normal"
                        id="date"
                        name="date"
                        label={"New Customers Since"}
                        format="MM/DD/yyyy"
                        value={date}
                        maxDate={new Date(Date.now())}
                        onChange={(date) => setDate(date)}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}/>}
                />)

            }
        </div>


    )
}


export default Tile;